import { useState, useEffect } from "react";
import { getCountdownParts } from "../lib/format";
import { useLang } from "../context/LanguageContext";

function Unit({ value, label, light }) {
  return (
    <div className="flex flex-col items-center">
      <span
        className={`font-heading tabular-nums leading-none ${light ? "text-[#F4F8FF]" : "text-[#0B1220]"}`}
        style={{ fontSize: "inherit" }}
      >
        {String(value).padStart(2, "0")}
      </span>
      <span
        className={`mt-1 text-[10px] uppercase tracking-[0.18em] ${light ? "text-[#F4F8FF]/60" : "text-[#5C6678]"}`}
      >
        {label}
      </span>
    </div>
  );
}

export function CountdownTimer({ date, variant = "hero", light = false, testid = "countdown" }) {
  const { t } = useLang();
  const [parts, setParts] = useState(() => getCountdownParts(date));

  useEffect(() => {
    setParts(getCountdownParts(date));
    const timer = setInterval(() => setParts(getCountdownParts(date)), 1000);
    return () => clearInterval(timer);
  }, [date]);

  if (parts.ended) {
    return (
      <span data-testid={testid} className={`text-sm ${light ? "text-[#F4F8FF]/70" : "text-[#5C6678]"}`}>
        {t("countdown.started")}
      </span>
    );
  }

  if (variant === "compact" || variant === "sticky") {
    return (
      <span data-testid={testid} className="font-mono-ibn tabular-nums text-sm font-medium tracking-tight">
        {parts.days}g {String(parts.hours).padStart(2, "0")}h {String(parts.minutes).padStart(2, "0")}m{" "}
        {variant === "sticky" ? "" : `${String(parts.seconds).padStart(2, "0")}s`}
      </span>
    );
  }

  const size = variant === "card" ? "text-2xl" : "text-4xl md:text-5xl";

  return (
    <div data-testid={testid} className={`flex items-start ${variant === "card" ? "gap-4" : "gap-6 md:gap-8"} ${size}`}>
      <Unit value={parts.days} label={t("countdown.days")} light={light} />
      <span className={`font-heading ${light ? "text-[#F4F8FF]/30" : "text-[#0B1220]/20"}`}>:</span>
      <Unit value={parts.hours} label={t("countdown.hours")} light={light} />
      <span className={`font-heading ${light ? "text-[#F4F8FF]/30" : "text-[#0B1220]/20"}`}>:</span>
      <Unit value={parts.minutes} label={t("countdown.min")} light={light} />
      {variant !== "card" && (
        <>
          <span className={`font-heading ${light ? "text-[#F4F8FF]/30" : "text-[#0B1220]/20"}`}>:</span>
          <Unit value={parts.seconds} label={t("countdown.sec")} light={light} />
        </>
      )}
    </div>
  );
}
